import { render, staticRenderFns } from "./ApplyResult.vue?vue&type=template&id=7974ba73&scoped=true&"
import script from "./ApplyResult.vue?vue&type=script&lang=js&"
export * from "./ApplyResult.vue?vue&type=script&lang=js&"
import style0 from "./ApplyResult.vue?vue&type=style&index=0&id=7974ba73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7974ba73",
  null
  
)

export default component.exports